// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__WG8cR","green":"Icon_green__zRzMp","blue":"Icon_blue__rIV3o"};